// project import
import pages from './pages';
import dashboard from './dashboard';
import { reactLocalStorage } from 'reactjs-localstorage';

import utilities from './utilities';
import support from './support';
import setting from './settings';
import pagesPo from './pages_po';
import pagesJastip from './pages_jastip';
import pagesReport from './pages_report';
import pagesExpense from './pages_expense';

// ==============================|| MENU ITEMS ||============================== //
let getUserInfo = reactLocalStorage.get('user_info')
getUserInfo = getUserInfo ? JSON.parse(getUserInfo) : null

// let items = [dashboard, pages]
let items = [
  pagesPo, 
  pagesJastip, 
  ... (getUserInfo && (!getUserInfo.role || getUserInfo.role == "superadmin")) ? [pagesReport] : [], 
  ... (getUserInfo && (!getUserInfo.role || getUserInfo.role == "superadmin")) ? [pagesExpense] : []
] 

if (getUserInfo && (!getUserInfo.role || getUserInfo.role == "superadmin")) {
  items.push(setting)
}

const menuItems = {
  items: items
};

export default menuItems;
